import {
  getDefaultFormatter,
  getDurationLevels
} from 'common/utils/time.utils';
import { numeralify } from 'common/utils/utils';
import round from 'lodash/round';
import { METRIC_TYPE } from '../consts/graphTypes';

export const yFormatter = unitType => {
  return FORMATTERS[unitType]?.yFormatter ?? null;
};

export const FORMATTERS = {
  timespan: {
    yFormatter(value, levels = 2) {
      return getDurationLevels({
        minutes: value,
        levels,
        format:
          levels === 2
            ? getDefaultFormatter({ minutes: value })
            : 'D[d], h[h], m[m]',
        ignoreZeros: true
      });
    },
    avgFormatter(avg, levels = 2, isShortUnitName = true) {
      const levelsFormatUnits = isShortUnitName
        ? {}
        : {
            minutesUnit: ' minutes',
            hoursUnit: ' hours',
            daysUnit: ' days',
            yearsUnit: ' years'
          };
      const formatUnits = isShortUnitName
        ? 'D[d], h[h], m[m]'
        : 'D[ days], h[ hours], m[ minutes]';
      return isNaN(avg)
        ? '-'
        : getDurationLevels({
            minutes: avg,
            levels,
            format:
              levels === 2
                ? getDefaultFormatter({ minutes: avg, ...levelsFormatUnits })
                : formatUnits,
            ignoreZeros: true
          });
    }
  },
  count: {
    yFormatter(value) {
      return numeralify(round(value, 2));
    },
    avgFormatter(avg) {
      return isNaN(avg) || avg === 0 ? '-' : numeralify(round(avg, 2));
    }
  },
  nonAvgCount: {
    yFormatter(value) {
      return numeralify(round(value, 2));
    },
    avgFormatter(avg) {
      return isNaN(avg) || avg === 0 ? '-' : numeralify(round(avg, 2));
    }
  },
  percentage: {
    yFormatter(value) {
      return `${numeralify(round(value, 2))}%`;
    },
    avgFormatter(avg) {
      return isNaN(avg) || avg === 0 ? '-' : `${numeralify(round(avg, 2))}%`;
    }
  },
  percentageWholeNumber: {
    yFormatter(value) {
      return `${numeralify(round(value, 0))}%`;
    },
    avgFormatter(avg) {
      return isNaN(avg) || avg === 0 ? '-' : `${numeralify(round(avg, 0))}%`;
    }
  }
};

export const formatToCustomMetric = ({ graph, metricsWithAggregation }) => {
  if (![METRIC_TYPE.pm, METRIC_TYPE.reported].includes(graph.metricType))
    return null;
  return [graph].map(
    ({ filters, metrics, id, calculation_strategy, ...rest }) => ({
      ...rest,
      custom_metric_id: id,
      include_issues: true,
      requested_metrics: metricsWithAggregation.map(({ name }) => name),
      filters,
      calculation_strategy
    })
  );
};

export const formatReportedMetricsResToCustomPmMetrics = response => {
  if (response.length === 0) {
    return [];
  }

  const responseObject = response[0];
  const { data } = responseObject;
  const metrics = [];
  data.forEach(window =>
    Object.keys(window)
      .filter(key => key !== 'before' && key !== 'after')
      .forEach(metricName => metrics.push(metricName))
  );
  const uniqueMetrics = [...new Set(metrics)];
  const widgets = uniqueMetrics.map(widgetKey => {
    const widgetId = parseInt(widgetKey.split(':')[0]);
    const metricName = widgetKey.split(':')[1];
    const newData = data.map(item => ({
      before: item.before,
      after: item.after,
      [metricName]: item[widgetKey]
    }));
    return { group: widgetId, data: newData };
  });
  return widgets;
};
